import { Link, NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import styles from "./Navbar.module.css";

const navItems = [
  { to: "/services", label: "Services", icon: "fas fa-briefcase" },
  { to: "/portfolio", label: "Portfolios", icon: "fas fa-images" },
  { to: "/about", label: "About", icon: "fas fa-user" },
];

function Navbar() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate("/login");
  };

  return (
    <header className={styles.navbar}>
      <div className={styles.navInner}>
        <Link to="/" className={styles.logo}>
          <img
            src="/assets/logoBig.png"
            alt="Build With Mak Inc"
            className={styles.logoImg}
          />
          <div className={styles.logoText}>Build With Mak Inc.</div>
        </Link>

        <nav className={styles.nav}>
          <ul className={styles.navLinks}>
            {navItems.map(({ to, label, icon }) => (
              <li key={to}>
                <NavLink
                  to={to}
                  className={({ isActive }) => (isActive ? styles.active : "")}
                >
                  <i className={`${icon} ${styles.navIcon}`}></i>
                  <span className={styles.navLabel}>{label}</span>
                </NavLink>
              </li>
            ))}
            {user && (
              <li>
                <NavLink
                  to="/dashboard"
                  className={({ isActive }) => (isActive ? styles.active : "")}
                >
                  <i className={`fas fa-gauge ${styles.navIcon}`}></i>
                  <span className={styles.navLabel}>Dashboard</span>
                </NavLink>
              </li>
            )}
            <li>
              {user ? (
                <button onClick={handleLogout} className={styles.logoutBtn}>
                  <i
                    className={`fas fa-right-from-bracket ${styles.navIcon}`}
                  ></i>
                  <span className={styles.navLabel}>Logout</span>
                </button>
              ) : (
                <NavLink
                  to="/login"
                  className={({ isActive }) => (isActive ? styles.active : "")}
                >
                  <i
                    className={`fas fa-right-to-bracket ${styles.navIcon}`}
                  ></i>
                  <span className={styles.navLabel}>Login</span>
                </NavLink>
              )}
            </li>
          </ul>
        </nav>
      </div>
    </header>
  );
}

export default Navbar;
